"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useReadinessCheck = require("./useReadinessCheck");
Object.keys(_useReadinessCheck).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useReadinessCheck[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useReadinessCheck[key];
    }
  });
});